import AboutUs from "../Components/Other/AboutUs";

const About = () => {
  return <AboutUs />;
};

export default About;
